import {Component, createRef} from "preact";
import {translate, TranslateService} from "../../../../../../services/TranslateService";
import SectionComponent from "../../../../../layout/section-component";
import VerticalUiContainer from "../../../../../layout/vertical-ui-container";
import ToolbarButton from "../../../../../common/toolbar-button";
import ArrowLeftIcon from "mdi-preact/ArrowLeftIcon";
import ToolbarTitle from "../../../../../layout/toolbar-title";
import Toolbar from "../../../../../layout/toolbar";
import JWTClient from "../../../../../../services/JWTClient";
import ModuleInfoProvider from "../../../../../../services/ModuleInfoProvider";
import JsonApiDeserializer from "../../../../../../services/JsonApiDeserializer";
import Spinner from "../../../../../common/spinner";
import BackdropCover from "../../../../../common/backdrop-cover";
import ScrollableSection from "../../../../../layout/scrollable-section";
import CustomInput from "../../../../../common/custom-input";
import SendIcon from "mdi-preact/SendIcon";
import styles from "./styles.scss";
import MessageListItem from "../message-list-item";
import ConfigService from "../../../../../../services/ConfigService";
import PlusIcon from "mdi-preact/PlusIcon";
import EmptyState from "../../../../../common/empty-state";
import ErrorState from "../../../../../common/error-state";
import InformationOutlineIcon from "mdi-preact/InformationOutlineIcon";
import ChatService from "../../../../../../services/ChatService";
import SectionContainer from "../../../../../layout/section-container";
import Text from "../../../../../common/text";
import dayjs from "dayjs";
import {newDate} from "../../../../../../utilities/date";
import SimpleDate from "../../../../../common/date/simple-date";
import Permission from "../../../../../common/permission/permission";

export default class MessageList extends Component {
    scrollableArea = createRef();

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            error: false,
            messages: [],
            previousPages: 0,
            text: '',
            sending: false,
            sendingError: false,
            user: ConfigService.userProfile().reference,
            chatSubjects: {}
        };
    }

    static defaultProps = {
        chat: {}
    };

    render(props, state, context) {
        const spinner = <BackdropCover><Spinner/></BackdropCover>;

        const loadMoreButton =
            <Toolbar>
                <ToolbarButton type={'fill'} onClick={this.nextPage}>
                    <PlusIcon/><Text text={'action.load-previous'}/>
                </ToolbarButton>
            </Toolbar>
        ;

        const emptyState = () => {
            return (!this.state.loading && !this.state.messages.length && !this.state.error) ?
                <EmptyState><Text text={'chat.read.empty'}/></EmptyState>
                : null;
        };

        const errorState = () => {
            return (!this.state.loading && this.state.error) ?
                <ErrorState><Text text={'error.loading'} /></ErrorState>
                : null;
        };

        const subjects = {};
        this.props.chat.subjects.forEach(s => {
            subjects[s.reference] = s;
        });

        let lastSender = null;
        let lastDate = dayjs('1970-01-01');
        const messages = [];
        for (let message of state.messages) {
            const date = dayjs(newDate(message.createdAt)).locale(ConfigService.currentLanguage());
            const isCloseToLastDate = Math.abs(lastDate.diff(date, 'second')) < 10;
            const isSameAsLastDate = lastDate.isSame(date, 'date');
            const isDateSameAsToday = dayjs().isSame(date, 'date');
            const isLastSender = lastSender === message.createdBy && isSameAsLastDate;

            if (!isSameAsLastDate) {
                messages.push(
                    <div class={styles.dateRow}>
                        <span>
                            {isDateSameAsToday ? TranslateService.t('today') : date.format('D MMM YYYY')}
                        </span>
                    </div>
                )
            }

            messages.push(
                <MessageListItem message={message}
                                 showUser={this.props.chat.type === 'groupChat' && !isLastSender && (!isSameAsLastDate || isCloseToLastDate)}
                                 sender={subjects[message.createdBy]}
                />
            );

            lastSender = message.createdBy;
            lastDate = date;
        }

        // messages.reverse();

        return (
            <VerticalUiContainer>
                {this.state.loading ? spinner : null}

                <Toolbar class={styles.toolbar}>
                    <SectionComponent style={{flexGrow: 0}}>
                        <ToolbarButton disabled={this.state.loading} onClick={this.backToList} title={translate('action.back')}><ArrowLeftIcon/></ToolbarButton>
                    </SectionComponent>

                    <SectionComponent>
                        <ToolbarTitle>{this.getChatTitle(this.props.chat)}</ToolbarTitle>
                    </SectionComponent>
                </Toolbar>

                <ScrollableSection class={styles.listContainer} ref={this.scrollableArea}>
                    {emptyState()}
                    {errorState()}
                    {this.state.previousPages ? loadMoreButton : null}
                    {messages}
                </ScrollableSection>

                <Permission permissions={['message.create']}>
                    <Toolbar>
                        <form onSubmit={this.onSubmit} class={styles.form}>
                            {state.sending ? spinner : null}
                            <div style={{flex: 2}}>
                                <CustomInput value={state.text} onChange={this.onTextChange} placeholder={translate('chat.input-placeholder')}/>
                            </div>
                            <div style={{flex: "0 0 auto"}}>
                                <ToolbarButton onClick={this.onSubmit} disabled={!this.state.text.length || this.state.sending} title={translate('action.send')}><SendIcon/></ToolbarButton>
                            </div>
                        </form>
                    </Toolbar>
                </Permission>
            </VerticalUiContainer>
        );
    }



    componentWillReceiveProps(nextProps, nextContext) {

    }

    onSubmit = (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (this.state.sending) return false;
        this.sendNewMessage();
        return false;
    };

    onTextChange = (inputEvent) => {
        this.setState({text: inputEvent.target.value});
    };

    getChatTitle(item) {
        if (item.title) return item.title;
        const subject = item.subjects.filter(s => s.reference !== this.state.user)[0];
        return subject.name || subject.email;
    }

    backToList = () => {
        return this.props.onNavigate('list');
    };

    nextPage = () => {
        if (this.state.previousPages) this.loadPreviousMessages();
    };

    componentDidMount() {
        this.readChat();
        this.loadPreviousMessages().then(() => this.scrollableArea.current.scrollFromBottom(0));
        ChatService.observable.subscribe(this.loadNextMessages);
    }

    componentWillUnmount() {
        ChatService.observable.unsubscribe(this.loadNextMessages);
    }

    readChat = () => {
        if (this.props.chat.read) return;
        const url = ModuleInfoProvider.getModuleWebServiceUrl('chat') + `/chats/${this.props.chat.id}/read`;
        JWTClient.fetch(url, {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({})
        });
    };

    loadPreviousMessages = () => {
        const firstSequenceNumber = this.state.messages.length ? this.state.messages[0].sequenceNumber : 1000000000;
        this.setState({loading: true, error: false});
        const filters = `?sortBy=sequenceNumber&direction=desc&limit=20&beforeSequenceNumber=` + firstSequenceNumber;
        const url = ModuleInfoProvider.getModuleWebServiceUrl('chat') + `/chats/${this.props.chat.id}/messages` + filters;
        return JWTClient.fetch(url)
            .then(res => {
                const messages = JsonApiDeserializer.deserializeItems(res.data, res.included);
                const newList = this.state.messages || [];
                const position = this.scrollableArea.current.scrollBottom();
                newList.unshift(...messages.reverse());
                this.setState({
                    messages: newList,
                    loading: false,
                    error: false,
                    previousPages: res.meta.pagination.total_pages - 1
                });
                setTimeout(() => {
                    this.scrollableArea.current.scrollFromBottom(position);
                }, 0);
            })
            .catch(e => {
                this.setState({loading: false, error: true});
            })
    };

    loadNextMessages = () => {
        const lastSequenceNumber = this.state.messages.length ? this.state.messages[this.state.messages.length - 1].sequenceNumber : 0;
        const filters = `?sortBy=sequenceNumber&direction=asc&afterSequenceNumber=` + lastSequenceNumber;
        const url = ModuleInfoProvider.getModuleWebServiceUrl('chat') + `/chats/${this.props.chat.id}/messages` + filters;
        JWTClient.fetch(url)
            .then(res => {
                const messages = JsonApiDeserializer.deserializeItems(res.data, res.included);
                const newList = this.state.messages || [];
                // save scroll position
                const position = this.scrollableArea.current.base.scrollTop;
                newList.push(...messages);
                this.setState({
                    messages: newList,
                    nextPages: res.meta.pagination.total_pages - 1
                });
                // scroll to previous position
                setTimeout(() => {
                    this.scrollableArea.current.base.scrollTop = position;
                }, 0);
                // read chat
                this.readChat();
            })
    };

    sendNewMessage() {
        this.setState({sending: true, sendingError: false})
        const url = ModuleInfoProvider.getModuleWebServiceUrl('chat') + `/messages`;
        const data = {
            content: this.state.text,
            chat: {id: parseInt(this.props.chat.id)}
        };

        JWTClient.fetch(url, {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(data)
        })
            .then(res => {
                const message = JsonApiDeserializer.deserializeItem(res.data, res.included);
                const messages = this.state.messages;
                messages.push(message);
                this.setState({
                    sending: false,
                    sendingError: false,
                    text: '',
                    messages: messages
                });
                setTimeout(() => this.scrollableArea.current.scrollFromBottom(0), 0);
            })
            .catch(err => {
                this.setState({
                    sending: false,
                    sendingError: true
                });
            })
        ;
    }

}



// WEBPACK FOOTER //
// ./components/sections/personal-area/sections/chat/message-list/index.js